package meineglasfaser.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import meineglasfaser.api.ubl.UBLPostalAddress
import kotlin.time.Instant

@Serializable
data class OrderLegacyCustomer(
    @SerialName("email")
    val email: String? = null,
    @SerialName("phone")
    val phone: String? = null,
    @SerialName("individual_first_name")
    val individualFirstName: String? = null,
    @SerialName("individual_last_name")
    val individualLastName: String? = null,
    @SerialName("individual_dob")
    val individualDob: String? = null,
    @SerialName("company_name")
    val companyName: String? = null,
    @SerialName("company_vat_number")
    val companyVatNumber: String? = null,
    @SerialName("company_contact_person")
    val companyContactPerson: String? = null,
    @SerialName("invoicing_account_holder")
    val invoicingAccountHolder: String? = null,
    @SerialName("invoicing_iban")
    val invoicingIBAN: String? = null,
)

@Serializable
data class Order(
    val id: String,
    val nid: Int,
    val customerName: String,
    val customer: Customer?,
    val customerLegacyData: OrderLegacyCustomer? = null,
    val deliveryAddress: UBLPostalAddress,
    val createdAt: Instant,
)

@Serializable
data class OrderEntry(
    val product: Product,
    val quantity: Int,
    val position: Int,
    val isAddon: Boolean,
)

@Serializable
data class OrderWithEntries(
    val order: Order,
    val entries: List<OrderEntry>,
)

@Serializable
data class OrderPaginated(
    val id: String,
    val nid: Int,
    val customerName: String?,
    val deliveryAddress: UBLPostalAddress,
    val createdAt: Instant,
)
